export class ListDataCatalogDatasetsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogDatasetsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
